import { Star } from 'lucide-react';
import { TESTIMONIALS, SITE } from '../lib/site';

const Testimonials = () => {
  return (
    <section id="opiniones" className="bg-paper-2 border-y border-line py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-14 reveal">
          <div>
            <p className="label">Opiniones reales</p>
            <h2 className="font-display font-black uppercase tracking-[-0.02em] text-section-title mt-5">
              Lo que dicen <em className="font-serifit normal-case font-normal text-clay">nuestros clientes</em>
            </h2>
          </div>
          <div className="flex items-center gap-4">
            <div className="text-left">
              <p className="stat-number text-4xl">{SITE.rating}<span className="text-clay">/5</span></p>
              <p className="text-[0.68rem] font-semibold uppercase tracking-[0.16em] text-ink-faint mt-1">+87 reseñas verificadas</p>
            </div>
            <div className="flex flex-col gap-0.5" aria-label={`${SITE.rating} de 5 estrellas`}>
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={13} className="fill-clay text-clay" />
              ))}
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-5 md:gap-6">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={t.name}
              className="reveal bg-paper border border-line rounded-[4px] p-8 md:p-10 flex flex-col gap-5"
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              <div className="flex items-center gap-1" aria-label="5 de 5 estrellas">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} size={14} className="fill-clay text-clay" />
                ))}
              </div>
              <blockquote className="text-ink text-lg leading-relaxed font-medium flex-1">
                “{t.text}”
              </blockquote>
              <figcaption className="flex items-center gap-4 pt-5 border-t border-line">
                <span className="grid place-items-center w-11 h-11 rounded-full bg-ink text-paper font-display font-bold text-sm">
                  {t.name.split(' ')[0][0]}{t.name.split(' ')[1]?.[0] ?? ''}
                </span>
                <div>
                  <p className="font-bold tracking-tight">{t.name}</p>
                  <p className="text-xs text-ink-faint mt-0.5">{t.project}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
